import React, { useEffect, useRef, useState } from "react";
import "./home.scss";
import {
  demoVideo,
  flower,
  homeBanner,
  homeBannerMb,
  images,
  leftArrowWhite,
  playicon,
  quoteicon,
  rightArrowWhite,
  sun,
  upDownArrowLightGreen,
} from "../../source";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import {
  exloreData,
  partnerLogo,
  reflectionData,
  testimonialData,
  upcomingEventsData,
} from "../../data/home";
import SectionContent from "../../components/SectionContent/SectionContent";
// import { VideoModal } from "../../components/VideoModal/VideoModal";
import ExploreBox from "../../components/ExploreBox/ExploreBox";
import UpcomingEvents from "../../components/UpcomingEvents/UpcomingEvents";
import CommonCta from "../../components/CommonCta/CommonCta";
import { useWindowSize } from "react-use";
import {
  aboutUsURL,
  interviewsURL,
  reflectionsURL,
} from "../../helpers/constants";
import FsLightbox from "fslightbox-react";
import config from "../../config/config";
import Joi from "joi";
import http from "../../helpers/http";
import { mainPostData } from "../../data/reflections";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const Home = () => {
  const { width } = useWindowSize();
  // const [modalShow, setModalShow] = useState(false);
  const [isHeight, setIsHeight] = useState(null);
  const getDivHeightRef = useRef();
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [vidLink, setVidLink] = useState("");
  const swiperRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    topic: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const schema = Joi.object({
    name: Joi.string().trim().required().messages({
      "string.empty": "Name is required",
      "any.required": "Name is required",
    }),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        "string.empty": "Email is required",
        "string.email": "Please enter a valid email address",
        "any.required": "Email is required",
      }),
    topic: Joi.string().required().messages({
      "string.empty": "Topic to Explore is required",
      "any.required": "Topic to Explore is required",
    }),
  });
  // const handleToggleModal = () => {
  //   setModalShow((prevState) => !prevState);
  // };

  const handleWatchClick = (videoLink) => {
    setIsVideoModalOpen(!isVideoModalOpen);
    setVidLink(videoLink);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowThankYou(false);
    // Validate form data
    const { error } = schema.validate(formData, { abortEarly: false });
    if (error) {
      const validationErrors = {};
      error.details.forEach((detail) => {
        validationErrors[detail.path[0]] = detail.message;
      });
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    try {
      const response = await http.post(
        `${config.api_url}/blog-leads`,
        formData
      );

      if (response) {
        // Reset form
        setFormData({
          name: "",
          email: "",
          topic: "",
        });

        // Show thank you message
        setShowThankYou(true);

        // Hide thank you message after 5 seconds
        setTimeout(() => {
          setShowThankYou(false);
        }, 5000);
      } else {
        throw new Error("Failed to submit form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrors({ submit: "Failed to submit form. Please try again." });
    } finally {
      setIsSubmitting(false);
    }
  };

  // const partnersLogoList = partnerLogo.map((logo, i) => (
  //   <SwiperSlide key={i}>
  //     <div className="logo_wrapper">
  //       <img src={logo.img} alt={logo.alt} className="partner_logo" />
  //     </div>
  //   </SwiperSlide>
  // ));

  useEffect(() => {
    if (width <= 992) {
      setIsHeight(getDivHeightRef.current.clientHeight);
      console.log("heigth", getDivHeightRef.current.clientHeight);
    }
  }, [isHeight, width]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Holistic Coaching, Therapy & Spiritual Growth - Pathways & Perspectives"
        metaDesc="Explore holistic coaching, trauma therapy, and spiritual healing with Pathways & Perspectives. Support for personal growth, emotional wellness & transformation in a safe, inclusive space.Learn more now!"
      />

      <section className="home_sec1" data-aos="fade">
        <div className="banner_wrapper">
          <img
            src={width > 767 ? homeBanner : homeBannerMb}
            alt="banner"
            className="banner_img"
          />
          <div className="content_wrapper">
            <h2 className="banner_heading">
              Discover Your Path. Uncover Your Light.
            </h2>
          </div>
        </div>

        {/* <div className="partners_slider_wrapper">
          <h2 className="partners_title">Our Partners</h2>
          <Swiper
            className="partner_slider"
            slidesPerView={4.5}
            spaceBetween={120}
            allowTouchMove={false}
            loop={true}
            speed={3000}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            breakpoints={{
              0: {
                slidesPerView: 2.8,
                spaceBetween: 120,
              },
              600: {
                slidesPerView: 3.88,
                spaceBetween: 120,
              },
              992: {
                slidesPerView: 4.88,
                spaceBetween: 120,
              },
              1280: {
                slidesPerView: 4.88,
                spaceBetween: 120,
              },
            }}
          >
            {partnersLogoList}
          </Swiper>
        </div> */}
      </section>

      <section className="home_sec2" data-aos="fade-up">
        <div className="my_container">
          <SectionContent
            title="Welcome to Pathways & Perspectives"
            h1Tag={true}
            description="Pathways & Perspectives brings you transformative conversations with spiritual teachers and visionary leaders, offering <strong>timeless and practical wisdom</strong> for modern life."
            ctaText="discover more"
            ctaLink={aboutUsURL}
          />
          <div className="video_wrapper" data-aos="fade-up">
            <img src={sun} alt="sun" className="sun_img" />
            {width > 767 ? (
              <img
                width={1640}
                height={600}
                src={images.videothumb.image}
                alt={images.videothumb.alt}
                className="video_thumb"
                loading="lazy"
              />
            ) : (
              <img
                width={343}
                height={450}
                src={images.videothumbMb.image}
                alt={images.videothumbMb.alt}
                className="video_thumb"
                loading="lazy"
              />
            )}
            {/* <img
              width={112}
              height={112}
              src={playicon}
              alt="play"
              className="play_icon"
              loading="lazy"
              onClick={() =>
                handleWatchClick(
                  "https://www.youtube.com/embed/Gn_inSHpZgk?si=ipX0q7PbKfzkGsa2"
                )
              }
            /> */}
          </div>
        </div>
        <div className="explore_wrap">
          <img
            src={upDownArrowLightGreen}
            alt="arrow"
            className="up_down_img"
          />
          <div className="my_container">
            {/* <div className="section_heading100 explore_title" data-aos="fade-up">
              Explore Pathways & Perspectives
            </div> */}
            <div className="explore_boxes row">
              {exloreData.map((data, i) => (
                <div
                  className="col-md-6 explore_box"
                  key={`explore-${i}`}
                  data-aos="fade-up"
                >
                  <ExploreBox
                    bgImg={data.img}
                    count={data.id}
                    title={data.title}
                    description={data.desc}
                    bgColor={data.bgColor}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="overlap_space" />
        </div>
      </section>

      <section className="home_sec3" data-aos="fade-up">
        {width > 767 && (
          <img src={flower} alt="flower" className="flower_img" />
        )}
        <div className="my_container">
          <UpcomingEvents
            // leftHeading="UPCOMING INTERVIEWS"
            leftHeading={`LATEST ${width > 992 ? "<br/>" : " "} INTERVIEWS`}
            lefDesc=" Immerse yourself in a space that fosters connection and
            personal growth."
            ctaText="view all"
            ctaLink={interviewsURL}
            eventsData={upcomingEventsData}
          />
        </div>
      </section>

      <section className="home_sec4">
        <div className="my_container">
          <div className="text_cta_container">
            <h2
              className="section_heading100 reflection_heading"
              data-aos="fade-up"
            >
              REFLECTIONS
            </h2>
            {width > 992 && (
              <CommonCta linkCta text="view all" link={reflectionsURL} />
            )}
          </div>
          {width > 992 ? (
            <div className="reflection_boxes">
              <div className="row ref_row">
                <div className="col-md-8 box-1" data-aos="fade-up">
                  <div className="reflection_box">
                    <img
                      width={1088}
                      height={556}
                      src={mainPostData[0].img}
                      alt=""
                      className="ref_thumb"
                      loading="lazy"
                    />
                    <p className="date">{mainPostData[0].date}</p>
                    <h3 className="title">{mainPostData[0].title}</h3>
                    <p className="name">{mainPostData[0].author}</p>
                    {mainPostData[0].ctaText && (
                      <CommonCta
                        linkCta
                        text={mainPostData[0].ctaText}
                        link={`${reflectionsURL}/${mainPostData[0].slug}`}
                      />
                    )}
                  </div>
                </div>
                <div className="col-md-4 box-2" data-aos="fade-up">
                  {/* <div className="reflection_box small">
                    <img
                      width={528}
                      height={236}
                      src={reflectionData[1].thumb}
                      alt=""
                      className="ref_thumb"
                      loading="lazy"
                    />
                    <p className="date">{reflectionData[1].date}</p>
                    <h3 className="title">{reflectionData[1].title}</h3>
                    <p className="name">- {reflectionData[1].name}</p>
                    {reflectionData[1].ctaText && (
                      <CommonCta
                        linkCta
                        text={reflectionData[1].ctaText}
                        link={reflectionData[1].ctaUrl}
                      />
                    )}
                  </div> */}

                  <form
                    className="posts_form form_wrapper"
                    onSubmit={handleSubmit}
                  >
                    <h2 className="form_title">
                      Request a topic to explore or a teacher to interview
                    </h2>
                    <div className="input_wrapper">
                      <input
                        type="text"
                        name="name"
                        className="input_field"
                        placeholder="Name*"
                        value={formData.name}
                        onChange={handleInputChange}
                      />
                      <p className="error">{errors.name || ""}</p>
                    </div>
                    <div className="input_wrapper">
                      <input
                        type="text"
                        name="email"
                        className="input_field"
                        placeholder="Email*"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      <p className="error">{errors.email || ""}</p>
                    </div>
                    <div className="input_wrapper">
                      <input
                        type="text"
                        name="topic"
                        className="input_field"
                        placeholder="Topic to Explore*"
                        value={formData.topic}
                        onChange={handleInputChange}
                      />
                      <p className="error">{errors.topic || ""}</p>
                    </div>
                    {errors.submit && <p className="error">{errors.submit}</p>}
                    <CommonCta
                      text={isSubmitting ? "SUBMITTING..." : "SUBMIT"}
                      type="submit"
                      disabled={isSubmitting}
                    />
                    <div className="thank_msg_wrapper">
                      {showThankYou && (
                        <p className="thank_text">
                          Thank you for your submission!
                        </p>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          ) : (
            <div className="reflection_boxes" data-aos="fade-up">
              <Swiper
                className="reflection_slider"
                modules={[Autoplay, Navigation]}
                slidesPerView={2}
                spaceBetween={20}
                loop={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                navigation={{
                  nextEl: ".right_arrow",
                  prevEl: ".left_arrow",
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                }}
              >
                {mainPostData.map((item, i) => (
                  <SwiperSlide key={i}>
                    <div className="ref_row">
                      <div className="box-2">
                        <div className="reflection_box small">
                          <div ref={getDivHeightRef}>
                            <img
                              width={528}
                              height={236}
                              src={item.img}
                              alt=""
                              className="ref_thumb"
                              loading="lazy"
                            />
                          </div>
                          <p className="date">{item.date}</p>
                          <h3 className="title">{item.title}</h3>
                          <p className="name">{item.author}</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
                <div
                  className="reflection_arrows"
                  style={{ top: `${isHeight / 2 - 20}px` }}
                >
                  <img
                    src={leftArrowWhite}
                    alt="left arrow"
                    className="left_arrow"
                  />
                  <img
                    src={rightArrowWhite}
                    alt="right arrow"
                    className="right_arrow"
                  />
                </div>
              </Swiper>
              {width <= 992 && (
                <CommonCta linkCta text="View All" link={reflectionsURL} />
              )}
              <div className="ref_row" data-aos="fade-up">
                <form
                  className="posts_form form_wrapper"
                  onSubmit={handleSubmit}
                >
                  <h2 className="form_title">
                    Request a topic to explore or a teacher to interview
                  </h2>
                  <div className="input_wrapper">
                    <input
                      type="text"
                      name="name"
                      className="input_field"
                      placeholder="Name*"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                    <p className="error">{errors.name || ""}</p>
                  </div>
                  <div className="input_wrapper">
                    <input
                      type="text"
                      name="email"
                      className="input_field"
                      placeholder="Email*"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                    <p className="error">{errors.email || ""}</p>
                  </div>
                  <div className="input_wrapper">
                    <input
                      type="text"
                      name="topic"
                      className="input_field"
                      placeholder="Topic to Explore*"
                      value={formData.topic}
                      onChange={handleInputChange}
                    />
                    <p className="error">{errors.topic || ""}</p>
                  </div>
                  {errors.submit && <p className="error">{errors.submit}</p>}
                  <CommonCta
                    text={isSubmitting ? "SUBMITTING..." : "SUBMIT"}
                    type="submit"
                    disabled={isSubmitting}
                  />
                  <div className="thank_msg_wrapper">
                    {showThankYou && (
                      <p className="thank_text">
                        Thank you for your submission!
                      </p>
                    )}
                  </div>
                </form>
              </div>
              {/* {width <= 992
                ? reflectionData[0].ctaText && (
                    <CommonCta
                      linkCta
                      text={reflectionData[0].ctaText}
                      link={reflectionData[0].ctaUrl}
                    />
                  )
                : null} */}
            </div>
          )}
        </div>
      </section>

      <section className="home_sec5">
        <div className="my_container">
          <h2
            className="section_heading100 testimonial_heading"
            data-aos="fade-up"
          >
            TESTIMONIALS
          </h2>
        </div>
        <div className="testimonial_wrapper" data-aos="fade-up">
          <Swiper
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            ref={swiperRef}
            modules={[Autoplay, Navigation]}
            slidesPerView={3.86}
            spaceBetween={20}
            centeredSlides={true}
            loop={testimonialData !== 0 ? true : false}
            speed={2000}
            allowTouchMove={false}
            freeMode={true}
            waitForTransition={false}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              // pauseOnMouseEnter: true,
            }}
            navigation={{
              nextEl: ".testimonial_right_arrow",
              prevEl: ".testimonial_left_arrow",
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2.5,
              },
              835: {
                slidesPerView: 3,
              },
              1025: {
                slidesPerView: 3.86,
              },
            }}
          >
            {testimonialData.map((data, i) => (
              <SwiperSlide key={`testimonial-${i}`}>
                <div
                  className="testimonial_box"
                  onMouseEnter={() => swiperRef.current?.autoplay?.stop()}
                  onMouseLeave={() => swiperRef.current?.autoplay?.start()}
                >
                  <img
                    width={67}
                    height={51}
                    src={quoteicon}
                    alt="quote"
                    className="quote_icon"
                    loading="lazy"
                  />
                  {/* <div className="title">{data.title}</div> */}
                  <div
                    className="desc"
                    dangerouslySetInnerHTML={{ __html: data.desc }}
                  ></div>
                  <div className="name_wrapper">
                    <img
                      width={80}
                      height={80}
                      src={data.img}
                      alt={data.name}
                      className="quote_img"
                      loading="lazy"
                    />
                    <div>
                      <h2 className="name">{data.name}</h2>
                      {data?.insta && (
                        <a
                          href={data?.instaLink}
                          className="name insta"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {data?.insta}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          {/* {width <= 767 && (
            <div className="testimonial_arrows">
              <img
                src={leftArrow}
                alt="left arrow"
                className="testimonial_left_arrow"
              />
              <img
                src={rightArrow}
                alt="right arrow"
                className="testimonial_right_arrow"
              />
            </div>
          )} */}
        </div>
      </section>

      {/* <VideoModal
        visibility={modalShow}
        onClose={() => setModalShow(false)}
        // videoSrc={demoVideo}
        videoSrc={"https://www.youtube.com/embed/Gn_inSHpZgk?si=ipX0q7PbKfzkGsa2"}
        // videoType="mp4"
        ytVideo
      /> */}

      <section className="home_lightbox_wrapper">
        <FsLightbox toggler={isVideoModalOpen} sources={[vidLink]} />
      </section>
    </>
  );
};

export default Home;
